export const tableHeader = [
    'SNo',
    'Session Name',
    'Course',
    'Subject',
    'Chapter',
    'Topic',
]